import { forwardRef, type Ref, type SVGProps } from "react";

function SvgArrowLeft(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.667 3.667 2.333 8l4.334 4.333M2.667 8h11"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgArrowLeft);
export default ForwardRef;
